import React, { Component } from 'react'
import { Modal, Row, Col } from "react-bootstrap";
import storage from "../../../../Storage";
import { sendNotfication, wait } from "../../../../Helper";
import General from "./General";
import Avatar from "./Avatar";
import Security from "./Security";

class Setting extends Component {
    constructor(props) {
        super(props);
        this.state = {
            show: false,
            general: true
        };
        this.handleShow = this.handleShow.bind(this);
        this.handleClose = this.handleClose.bind(this);
    }

    handleClose() {
        this.setState({ show: false, effect: 'delayAn zoomOut' });
        wait(500).then(() => {
            this.setState({ general: true })
        })
    }

    handleShow() {
        if (storage.getKey('token') === null) {
            return sendNotfication('Please Login !', 'warning', 'top-center');
        }
        this.setState({ show: true, effect: 'delayAn pulse' });
    }

    changePage = (e) => {
        this.setState({ general: !this.state.general })
    };

    render() {
        const { sidebar } = this.props;
        return (
            <>
                {sidebar ? (
                    <span onClick={this.handleShow} className="cursor-pointer">
                        Settings
                    </span>
                ) : (
                    <span onClick={this.handleShow} className={"dropdown-item"}>
                        <i className="dripicons-gear text-muted mr-2 text-drop" />
                        Settings
                    </span>
                )}

                <Modal
                    size="md"
                    centered={true}
                    backdrop={'static'}
                    show={this.state.show}
                    onHide={this.handleClose}
                    aria-labelledby="setting-lg-modal"
                    className={"auth-modal-custom animated " + this.state.effect}
                >
                    <Modal.Header>
                        <div className="auth-welcome-text" style={{ fontSize: '1.25rem' }}>
                            Settings
                        </div>
                        <button type="button" className="close" onClick={this.handleClose}>
                            <i className={'mdi mdi-close'} />
                        </button>
                    </Modal.Header>
                    <Modal.Body className="p-0">
                        <div className="auth-form-container">
                            {this.state.general &&
                                <div className="animated fadeIn">
                                    <Avatar />
                                    <div className="mt-4">
                                        <General />
                                    </div>
                                    <div className="text-center mt-4 pt-2">
                                        <button className="btn btn-link text-success p-0 font-weight-bold" onClick={this.changePage} style={{ textDecoration: 'none', fontSize: '0.9rem' }}>
                                            <i className="mdi mdi-lock-reset mr-2"></i> Change Password
                                        </button>
                                    </div>
                                </div>
                            }
                            {!this.state.general &&
                                <div className="animated fadeIn">
                                    <Security clicked={this.changePage} />
                                </div>
                            }
                        </div>
                    </Modal.Body>
                </Modal>
            </>
        );
    }
}

export default Setting;